export function initVariantSelection() {
    const root = document.querySelector('.js-variantSelection');
    if (!root) return;

    const isSimple = root.dataset.simple === '1' || root.dataset.simple === 'true';
    const grid = loadVariantGrid(root);

    const yearEl = root.querySelector('#yearSelect');
    const volEl = root.querySelector('#volumeSelect');
    const variantSelect = root.querySelector('#variantSelect');

    const isDropdownMode = root.classList.contains('dropdown-mode');

    if (isDropdownMode && variantSelect) {
        initDropdownMode(variantSelect, root);
        return;
    }

    if (!volEl) return;

    const yearDropdown = root.querySelector('.variantSelection__row:first-child .customSelect__dropdownBody');
    const volumeDropdown = root.querySelector('.variantSelection__row:last-child .customSelect__dropdownBody');

    if (isSimple || !yearEl) {
        initSimpleMode(volEl, root, grid);
        return;
    }

    updateDisabledForVolume(yearEl, volEl, grid, yearEl.value);
    updateDisabledForYear(yearEl, volEl, grid, volEl.value);

    let lastSelectedYear = yearEl.value;
    let lastSelectedVolume = volEl.value;

    yearDropdown?.addEventListener('click', e => {
        const item = e.target.closest('[data-value]');
        if (!item || item.classList.contains('disabled')) return;
        const value = item.dataset.value;
        yearEl.value = value;
        onYearChange(yearEl, volEl, grid, lastSelectedYear, newYear => { lastSelectedYear = newYear; });
    });

    volumeDropdown?.addEventListener('click', e => {
        const item = e.target.closest('[data-value]');
        if (!item || item.classList.contains('disabled')) return;
        const value = item.dataset.value;
        volEl.value = value;
        onVolumeChange(yearEl, volEl, grid, lastSelectedVolume, newVolume => { lastSelectedVolume = newVolume; });
    });

    yearEl?.addEventListener('change', () => {
        onYearChange(yearEl, volEl, grid, lastSelectedYear, newYear => { lastSelectedYear = newYear; });
    });
    volEl.addEventListener('change', () => {
        onVolumeChange(yearEl, volEl, grid, lastSelectedVolume, newVolume => { lastSelectedVolume = newVolume; });
    });
}

function isSameUrl(link) {
    try {
        return new URL(link, window.location.href).href === window.location.href;
    } catch {
        return link === window.location.pathname || link === window.location.href;
    }
}

function initDropdownMode(variantSelect, root) {
    const handleNavigation = () => {
        const link = variantSelect.value;
        if (link && !isSameUrl(link)) {
            variantSelect.disabled = true;
            variantSelect.closest('.customSelect')?.classList.add('is-loading');
            window.location.assign(link);
        }
    };

    variantSelect.addEventListener('change', handleNavigation);

    root.addEventListener('click', (e) => {
        e.preventDefault();
        const item = e.target.closest('.customSelect__dropdownItem--link');
        if (item) {
            const link = item.getAttribute('data-value');
            if (link && link !== variantSelect.value) {
                variantSelect.value = link;
                variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    });
}

function loadVariantGrid(root) {
    const gridEl = root.querySelector('script.variant-grid');
    try {
        return JSON.parse(gridEl?.textContent || '{}');
    } catch {
        return {};
    }
}

function normVol(v) {
    return String(v).trim().toUpperCase();
}

function initSimpleMode(volEl, root, grid) {
    Array.from(volEl.options).forEach(opt => {
        const vKey = normVol(opt.value);
        const available = grid[vKey]?.disabled === false;
        opt.disabled = !available;
        const item = root.querySelector('.customSelect__dropdownBody [data-value="' + (window.CSS?.escape ? CSS.escape(vKey) : vKey) + '"]');
        if (item) item.classList.toggle('disabled', !available);
    });

    volEl.addEventListener('change', () => {
        const vKey = normVol(volEl.value);
        const cell = grid[vKey];
        if (cell && cell.disabled === false && cell.link) {
            volEl.closest('.customSelect')?.classList.add('is-loading');
            window.location.assign(cell.link);
        }
    });

    root.addEventListener('click', (e) => {
        const item = e.target.closest('.variantSelection__row .customSelect__dropdownBody [data-value]');
        if (!item || item.classList.contains('disabled')) return;
        const vRaw = item.getAttribute('data-value');
        volEl.value = vRaw;
        volEl.dispatchEvent(new Event('input',  { bubbles: true }));
        volEl.dispatchEvent(new Event('change', { bubbles: true }));
    }, { passive: true });
}

function isAvailable(grid, y, v) {
    const year = String(y).trim();
    const volume = normVol(v);
    return grid[year]?.[volume]?.disabled === false;
}

function firstAvailableVolumeForYear(grid, y) {
    const year = String(y).trim();
    const row = grid[year] || {};
    return Object.keys(row).find(k => row[k]?.disabled === false) || null;
}

function firstAvailableYearForVolume(grid, v) {
    const volume = normVol(v);
    return Object.keys(grid).find(y => grid[y]?.[volume]?.disabled === false) || null;
}

function existsInAnyYear(grid, v) {
    const volume = normVol(v);
    return Object.values(grid).some(row => row[volume]?.disabled === false);
}

function existsAnyVolumeForYear(grid, y) {
    const year = String(y).trim();
    const row = grid[year] || {};
    return Object.values(row).some(variant => variant?.disabled === false);
}

function updateDisabledForVolume(yearEl, volEl, grid, y) {
    const year = String(y).trim();
    Array.from(volEl.options).forEach(opt => {
        const vKey = normVol(opt.value);
        const globallyAvail = existsInAnyYear(grid, vKey);
        const availableForThisYear = grid[year]?.[vKey]?.disabled === false;
        opt.disabled = !globallyAvail;
        const item = volEl.closest('.customSelect').querySelector(`[data-value="${vKey}"]`);
        if (item) {
            item.classList.toggle('disabled', !globallyAvail);
            item.classList.toggle('unavailable', globallyAvail && !availableForThisYear);
        }
    });
}

function updateDisabledForYear(yearEl, volEl, grid, v) {
    const volume = normVol(v);
    Array.from(yearEl.options).forEach(opt => {
        const year = String(opt.value).trim();
        const globallyAvailYear = existsAnyVolumeForYear(grid, year);
        const availableForThisVolume = grid[year]?.[volume]?.disabled === false;
        opt.disabled = !globallyAvailYear;
        const item = yearEl.closest('.customSelect').querySelector(`[data-value="${year}"]`);
        if (item) {
            item.classList.toggle('disabled', !globallyAvailYear);
            item.classList.toggle('unavailable', globallyAvailYear && !availableForThisVolume);
        }
    });
}

function navigateTo(grid, y, v) {
    const year = y ? String(y).trim() : null;
    const volume = v ? normVol(v) : null;
    let link = null;

    if (year && volume && grid[year]?.[volume]?.disabled === false) {
        link = grid[year][volume].link;
    } else if (!year && volume && grid[volume]?.disabled === false) {
        link = grid[volume].link;
    }

    if (link) window.location.assign(link);
}

function onYearChange(yearEl, volEl, grid, lastSelectedYear, updateCallback) {
    const y = yearEl.value;

    updateDisabledForVolume(yearEl, volEl, grid, y);
    let v = volEl.value;

    if (!isAvailable(grid, y, v)) {
        const fav = firstAvailableVolumeForYear(grid, y);
        if (fav) {
            volEl.value = fav;
            v = fav;
        }
    }

    updateCallback(y);
    navigateTo(grid, y, v);
}

function onVolumeChange(yearEl, volEl, grid, lastSelectedVolume, updateCallback) {
    const v = volEl.value;

    let y = yearEl?.value;
    if (yearEl) {
        updateDisabledForYear(yearEl, volEl, grid, v);
        if (!isAvailable(grid, y, v)) {
            const favY = firstAvailableYearForVolume(grid, v);
            if (favY) {
                yearEl.value = favY;
                y = favY;
            }
        }
    } else {
        y = firstAvailableYearForVolume(grid, v);
    }

    updateCallback(v);
    navigateTo(grid, y, v);
}
